import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import axios from 'axios';
import { environment } from '../../../../environments/environment';
import { ToastService } from '../../../services/toast.service';
import formData from './form.json';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-new-incident',
  templateUrl: './new-incident.component.html',
  styleUrls: [
    './new-incident.component.scss',
    '../../../components/modal/modal.component.scss'
  ]
})
export class NewIncidentComponent implements OnInit {
  @HostListener('ngModelChange', ['$event'])
  onTimeChange(event, type) {
    // force xx:xx format on incident jumper time fields
    if (type === 'arrival') {
      if (event.length === 2) {
        event = event + ':';
      }
      this.jumperArrivalTime = event;
    }
    if (type === 'return') {
      if (event.length === 2) {
        event = event + ':';
      }
      this.jumperReturnTime = event;
    }
    if (type === 'arrivalDate') {
      this.jumperArrivalDate = event;
      if (this.jumperArrivalDate && this.jumperReturnDate) {
        let arrivalTimestamp = new Date(this.jumperArrivalDate).getTime();
        let returnTimestamp = new Date(this.jumperReturnDate).getTime();
        this.totalDays =
          (returnTimestamp - arrivalTimestamp) / 1000 / 60 / 60 / 24 + 1;
      }
    }
    if (type === 'returnDate') {
      this.jumperReturnDate = event;
      if (this.jumperArrivalDate && this.jumperReturnDate) {
        let arrivalTimestamp = new Date(this.jumperArrivalDate).getTime();
        let returnTimestamp = new Date(this.jumperReturnDate).getTime();
        this.totalDays =
          (returnTimestamp - arrivalTimestamp) / 1000 / 60 / 60 / 24 + 1;
      }
    }
  }

  loading = true;

  token = window.sessionStorage.getItem('token');
  userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));

  // default mode is 'Create' for /new
  mode = 'Create';

  // import generic form sections from ./form.json
  sections = formData.sections;

  // new incident object
  data = {
    _asstSpotterId: null,
    _pilotId: null,
    _copilotId: null,
    _spotterId: null,
    _spotterTraineeId: null,
    _acres: null,
    _latitude: '',
    _longitude: '',
    _hobbsTime: '',
    _baseCode: '',
    id: '',
    _notes: '',
    _incidentDate: null,
    _nameofIncident: null,
    _dispatchedFrom_Code: null,
    _areaId: null,
    _stateId: null,
    _methodOfTravel_Id: null,
    _identifierId: null,
    _agencyId: null,
    _mode: null,
    _mission: null,
    _departTimeMilitary: null
  };

  // modal vars
  modal = {
    active: false,
    data: {}
  };

  // endpoint data vars
  allUnfilteredChutes = {
    main: [],
    drogue: [],
    reserve: [],
  }
  mainChutes;
  drogueChutes;
  reserveChutes;
  bases;
  dispandreturn;
  allPilots;
  pilots;
  travelmodes;
  states;
  agency;
  area;
  qualifications;
  activeQualifications;
  jumpers;
  allJumpers;
  activeJumpers;
  identifiers;
  originalIdentifiers;
  spotters = [];
  spotterTrainees = [];

  // incident jumper vars
  selectedIdentifier = {
    id: '',
    value: '',
    name: ''
  };
  selectedMainChute = {
    id: '',
    name: '',
    value: ''
  };
  selectedDrogueChute = {
    id: '',
    value: ''
  };
  selectedReserveChute = {
    id: '',
    value: ''
  };
  selectedBase = {
    baseCode: '',
    value: ''
  };
  selectedJumper = {
    friendly: '',
    id: '',
    base: {
      id: ''
    },
    lastName: '',
    firstName: '',
    name: '',
    value: ''
  };
  selectedPosition1 = {
    id: ''
  };
  selectedPosition2 = {
    id: ''
  };
  selectedPosition3 = {
    id: ''
  };
  T1;
  T2;
  T3;
  totalDays;
  jumpRating = {
    name: '',
    value: ''
  };
  jumperReturnDate;
  jumperReturnTime;
  jumperArrivalDate;
  jumperArrivalTime;
  incidentJumpers = [];
  editingJumper = false;

  constructor(private router: Router, private toast: ToastService) {}

  ngOnInit() {
    // if we see an '/:id' instead of '/new' in the URL,
    // we are in "update" mode instead of "create" mode
    let url = window.location.href;
    let id = url.slice(url.lastIndexOf('/') + 1, url.length);
    if (id.includes(';')) {
      id = url.slice(url.lastIndexOf('/') + 1, url.indexOf(';'));
    }
    if (id !== 'new') {
      this.mode = 'Update';
    }
    this.loadFormData(id);
  }

  // get incident info
  beginUpdateMode = async (id) => {
    let incident = await axios.get(environment.API_URL + '/incidents/' + id, {
      headers: { Authorization: 'Bearer ' + this.token }
    });
    this.data = incident.data;
    this.data.id = id;
    // add legacy pilots to pilot dropdowns for display
    if (this.data.id) {
      this.allPilots.forEach((pilot) => {
        // get the pilot id from the pilot href
        let pilotId = pilot.href.slice(
          pilot.href.lastIndexOf('/') + 1,
          pilot.href.length
        );
        // add the pilot to the pilot dropdown for display of chosen inactive pilots
        if (pilotId.toString() === this.data._pilotId?.toString() && !pilot.active) {
          pilot.name = pilot.lastName + ', ' + pilot.firstName + ' | ' + pilot.baseCode;
          pilot.value = pilotId;
          this.pilots.push(pilot);
        }
        if (pilotId.toString() === this.data._copilotId?.toString() && !pilot.active) {
          pilot.name = pilot.lastName + ', ' + pilot.firstName + ' | ' + pilot.baseCode;
          pilot.value = pilotId;
          this.pilots.push(pilot);
        }
      })
    }

    // show date in friendly format
    let date = this.data._incidentDate.split('-');
    this.data._incidentDate =
      date[0] + '-' + date[1] + '-' + date[2].substr(0, 2);

    if (this.data._departTimeMilitary) {
      if (this.data._departTimeMilitary.length === 4) {
        this.data._departTimeMilitary =
          this.data._departTimeMilitary.slice(0, 2) +
          ':' +
          this.data._departTimeMilitary.slice(2, 4);
      }
      if (this.data._departTimeMilitary.length === 3) {
        this.data._departTimeMilitary =
          this.data._departTimeMilitary.slice(0, 1) +
          ':' +
          this.data._departTimeMilitary.slice(1, 3);
      }
    }

    this.populateSpotters()

    this.sections.forEach((section) => {
      section.data.forEach((datum) => {
        if (datum.endpoint) {
          datum.options = this[datum.endpoint];
        }
        if (datum.dropdown || datum.combobox || datum.identifiers) {
          if (this.data[datum.key]) {
            let choice = datum.options.filter((option) => {
              let optString = option.value;
              let dataString = this.data[datum.key];
              return optString.toString() === dataString.toString();
            });
            if (choice.length) {
              datum.choice = choice[0];
            }
          }
        }
      });
    });


    // after the data is loaded into the form
    // we can start filtering any datasets that need it
    // i.e. identifiers
    this.identifiers = [{ name: '', value: '' }];
    this.filterIdentifiers();

    // get any jumpers associated with the incident
    this.refreshIncidentJumpers();
  };

  // get all the data from the backend that is used to populate the form fields
  loadFormData = async (incidentId) => {
    this.loading = true;
    this.clearForm();

    let identifiers = await axios.get(environment.API_URL + '/identifier', {
      headers: { Authorization: 'Bearer ' + this.token }
    });
    this.identifiers = identifiers.data;
    this.identifiers.forEach((identifier) => {
      identifier.name = identifier.text;
      identifier.value = identifier.id;
    });
    this.originalIdentifiers = this.identifiers;

    // get jumpers
    this.getJumpers()

    // get bases
    let bases = await axios.get(environment.API_URL + '/base/dropdown/main', {
      headers: { Authorization: 'Bearer ' + this.token }
    });
    this.bases = bases.data;

    // get dispatch and return bases
    let disps = await axios.get(
      environment.API_URL + '/base/dropdown/dispandreturn/',
      {
        headers: { Authorization: 'Bearer ' + this.token }
      }
    );
    this.dispandreturn = disps.data;
    this.dispandreturn.forEach((disp) => {
      disp.name = disp.text + ' | ' + disp.baseCode;
    });
    this.dispandreturn = this.sort(this.dispandreturn, 'name');
    this.dispandreturn = this.sort(this.dispandreturn, 'baseCode');

    // sort dispatch and return bases
    let userDisps = this.dispandreturn.filter((disp) => {
      return disp.baseCode === this.userInfo.baseCode;
    });
    let otherDisps = this.dispandreturn.filter((disp) => {
      return disp.baseCode !== this.userInfo.baseCode;
    });
    this.dispandreturn = userDisps.concat(otherDisps);

    // get pilots
    let pilots = await axios.get(environment.API_URL + '/pilots', {
      headers: { Authorization: 'Bearer ' + this.token }
    });
    this.allPilots = pilots.data.value;
    // filter to only show "active" pilots
    this.pilots = pilots.data.value.filter(pilot => {
      return pilot.active === true;
    });
    this.pilots.forEach((pilot) => {
      let id = pilot.href.slice(
        pilot.href.lastIndexOf('/') + 1,
        pilot.href.length
      );
      pilot.name =
        pilot.lastName + ', ' + pilot.firstName + ' | ' + pilot.baseCode;
      pilot.value = id;
    });

    // sort pilots
    let userPilots = this.pilots.filter((pilot) => {
      return pilot.baseCode === this.userInfo.baseCode;
    });
    let otherPilots = this.pilots.filter((pilot) => {
      return pilot.baseCode !== this.userInfo.baseCode;
    });
    this.pilots = userPilots.concat(otherPilots);

    // add "empty" selection
    this.pilots.unshift({ name: '', value: '' });

    // get travel modes
    let travelmodes = await axios.get(environment.API_URL + '/travelmodes', {
      headers: { Authorization: 'Bearer ' + this.token }
    });
    this.travelmodes = travelmodes.data.value;
    this.travelmodes.forEach((travelmode) => {
      let id = Number(
        travelmode.href.slice(
          travelmode.href.lastIndexOf('/') + 1,
          travelmode.href.length
        )
      );
      travelmode.value = id;
      if (
        travelmode.Aircraft_Name === 'Ground\t' ||
        travelmode.Aircraft_Name === 'Other' ||
        travelmode.Aircraft_Name === 'Helicopter' ||
        travelmode.Aircraft_Name === 'Contract Air' ||
        travelmode.Aircraft_Name === 'Commercial Air'
      ) {
        travelmode.name = travelmode.Aircraft_Name;
      } else {
        travelmode.name =
          travelmode.Aircraft_Name +
          ' | ' +
          travelmode.Aircraft_Tail_Number +
          ' | ' +
          travelmode.homeBase;
      }
    });

    // match legacy sort order
    this.travelmodes = this.sort(this.travelmodes, 'Aircraft_Name');
    this.travelmodes = this.sort(this.travelmodes, 'homeBase');
    // put "other" types on bottom to match legacy
    for (let index = 0; index < 5; index++) {
      let travelmode = this.travelmodes.shift();
      this.travelmodes.push(travelmode);
    }
    // put travel modes that match the user's base on top of list
    let userModes = this.travelmodes.filter((mode) => {
      return mode.homeBase === this.userInfo.baseCode;
    });
    let otherModes = this.travelmodes.filter((mode) => {
      return mode.homeBase !== this.userInfo.baseCode;
    });
    this.travelmodes = userModes.concat(otherModes);
    // filter out inactive
    this.travelmodes = this.travelmodes.filter((mode) => {
      return !mode.deleted
    })

    // get states
    let states = await axios.get(environment.API_URL + '/states', {
      headers: { Authorization: 'Bearer ' + this.token }
    });
    this.states = states.data;
    this.states.forEach((state) => {
      state.name = state.text;
      state.value = state.id;
    });

    // get agencies
    let agencies = await axios.get(environment.API_URL + '/agency', {
      headers: { Authorization: 'Bearer ' + this.token }
    });
    this.agency = agencies.data;
    this.agency.forEach((agency) => {
      agency.name = agency.text;
      agency.value = agency.id;
    });

    // get areas
    let areas = await axios.get(environment.API_URL + '/area', {
      headers: { Authorization: 'Bearer ' + this.token }
    });
    this.area = areas.data;
    this.area.forEach((area) => {
      area.name = area.text;
      area.value = area.id;
    });

    // get quals
    let qualifications = await axios.get(environment.API_URL + '/Quals', {
      headers: { Authorization: 'Bearer ' + this.token }
    });
    this.qualifications = qualifications.data.value
    this.qualifications.forEach((qualification) => {
      qualification.name = qualification.title + ' | ' + qualification.Acronym;
      qualification.value = qualification.id;
    });
    this.qualifications = this.sort(this.qualifications, 'title');
    this.activeQualifications = this.qualifications.filter((qual) => {
      return qual.active
    })

    // get main chutes data
    let mainChutes = (await axios.get(environment.API_URL + '/chutemain', {
      headers: { Authorization: 'Bearer ' + this.token },
      params: { limit: 100000 }
    })).data.value;

    mainChutes.forEach((chute) => {
      let id = chute.href.slice(
        chute.href.lastIndexOf('/') + 1,
        chute.href.lastIndexOf('?') !== -1 ? chute.href.lastIndexOf('?') : chute.href.length + 1
      );
      id = Number(id);
      chute.name = chute.main + ' | ' + chute.Base;
      chute.value = id;
      chute.id = id;
    });
    mainChutes = this.sort(mainChutes, 'main');
    mainChutes = this.sort(mainChutes, 'Base');
    this.allUnfilteredChutes.main = mainChutes;

    this.mainChutes = mainChutes.filter((chute) => {
      return chute.inService === true;
    });

    // get drogue chutes data
    let drogueChutes = (await axios.get(environment.API_URL + '/chutedrogue', {
      headers: { Authorization: 'Bearer ' + this.token },
      params: { limit: 100000 }
    })).data.value;
    drogueChutes.forEach((chute) => {
      let id = chute.href.slice(
        chute.href.lastIndexOf('/') + 1,
        chute.href.lastIndexOf('?') !== -1 ? chute.href.lastIndexOf('?') : chute.href.length + 1
      );
      id = Number(id);
      chute.name = chute.drogue + ' | ' + chute.Base;
      chute.value = id;
      chute.id = id;
    });
    drogueChutes = this.sort(drogueChutes, 'drogue');
    drogueChutes = this.sort(drogueChutes, 'Base');
    this.allUnfilteredChutes.drogue = drogueChutes
    this.drogueChutes = drogueChutes.filter((chute) => {
      return chute.inService === true;
    });

    // get reserve chutes data
    let reserveChutes = (await axios.get(environment.API_URL + '/chutereserve', {
      headers: { Authorization: 'Bearer ' + this.token },
      params: { limit: 100000 }
    })).data.value;
    reserveChutes.forEach((chute) => {
      let id = chute.href.slice(
        chute.href.lastIndexOf('/') + 1,
        chute.href.lastIndexOf('?') !== -1 ? chute.href.lastIndexOf('?') : chute.href.length + 1
      );
      id = Number(id);
      chute.name = chute.reserve + ' | ' + chute.Base;
      chute.value = id;
      chute.id = id;
    });
    reserveChutes = this.sort(reserveChutes, 'reserve');
    reserveChutes = this.sort(reserveChutes, 'Base');
    this.allUnfilteredChutes.reserve = reserveChutes;
    this.reserveChutes = reserveChutes.filter((chute) => {
      return chute.inService === true;
    });

    // populate form options
    this.sections.forEach((section) => {
      section.data.forEach((datum) => {
        if (datum.endpoint) {
          datum.options = this[datum.endpoint];
        }
        if (datum.dropdown || datum.combobox || datum.identifiers) {
          if (this.data[datum.key]) {
            let choice = datum.options.filter((option) => {
              let optString = option.value;
              let dataString = this.data[datum.key];
              return optString.toString() === dataString.toString();
            });
            if (choice.length) {
              datum.choice = choice[0];
            }
          }
        }
      });
    });

    if (incidentId !== 'new') {
      this.mode = 'Update';
      this.beginUpdateMode(incidentId);
    } else {
      // after the data is loaded into the form
      // we can start filtering any datasets that need it
      // i.e. identifiers
      this.identifiers = [{ name: '', value: '' }];
      this.filterIdentifiers();
      this.loading = false;
    }
  };

  getJumpers = async () => {
    this.loading = true;
    let jumpers = await axios.get(environment.API_URL + '/jumpers', {
      headers: { Authorization: 'Bearer ' + this.token }
    });
    this.jumpers = jumpers.data.value;
    this.jumpers.forEach((jumper) => {
      jumper.friendly =
        jumper.lastName + ', ' + jumper.firstName + ' | ' + jumper.base.code;

      jumper.basecode = jumper.base.code;
    });

    this.jumpers = this.sort(this.jumpers, 'friendly');
    this.jumpers = this.sort(this.jumpers, 'basecode');
    this.allJumpers = this.jumpers;
    this.allJumpers.forEach((jumper) => {
      jumper.name = jumper.friendly;
      jumper.value = jumper.id;
    });

    this.loading = false;

    // put base jumpers at the top
    let userJumpers = this.allJumpers.filter((jumper) => {
      return jumper.basecode === this.userInfo.baseCode;
    });
    let otherJumpers = this.allJumpers.filter((jumper) => {
      return jumper.basecode !== this.userInfo.baseCode;
    });
    this.allJumpers = userJumpers.concat(otherJumpers);

    // filter out jumpers from other bases if a base is selected
    if (this.selectedBase.baseCode !== '') {
      this.jumpers = this.jumpers.filter((jumper) => {
        return jumper.basecode === this.selectedBase.baseCode;
      });
    }

    this.populateSpotters()

    this.activeJumpers = this.jumpers.filter((jumper) => {
      return jumper.activeStatus;
    });
  };

  populateSpotters = () => {
    this.spotters = []
    this.spotterTrainees = []

    // allow blank entries for 1st spotter and trainee
    this.spotters.push({ id: '', name: '', value: '' });
    this.spotterTrainees.push({ id: '', name: '', value: '' });

    this.allJumpers.forEach((jumper) => {
      if (jumper.id === this.data._spotterId || jumper.id === this.data._asstSpotterId) {
        this.spotters.push(jumper)
      } else if (jumper.id === this.data._spotterTraineeId) {
        this.spotterTrainees.push(jumper)
      } 
      
      if (jumper.spotter === 'Spotter' && !jumper.retired && jumper.activeStatus) {
        this.spotters.push(jumper);
      } else if (jumper.spotter === 'Trainee' && !jumper.retired && jumper.activeStatus) {
        this.spotterTrainees.push(jumper);
      }
    });
  }

  clearForm = () => {
    this.sections.forEach((section) => {
      section.data.forEach((datum) => {
        if (datum.dropdown || datum.identifiers || datum.combobox) {
          datum.choice = {};
        }
      });
    });
  };

  submitForm = (data) => {
    window.scrollTo(0, 0);
    this.loading = true;
    let userId = this.userInfo.id;
    let options = {
      headers: { Authorization: 'Bearer ' + this.token }
    };
    let url = environment.API_URL + '/incidents/add?userId=' + userId;

    if (!this.data._hobbsTime) {
      delete this.data._hobbsTime;
    }

    // submit a new incident
    if (this.mode === 'Create' && this.loading) {
      this.loading = true;

      this.data._baseCode = this.userInfo.basecode;
      axios
        .post(url, this.data, options)
        .then((response) => {
          this.toast.show('Created incident', 'success');
          this.router.navigate(['/incidents/' + response.data]);
          // workaround for ngIf element not in DOM on initial page load
          // let scrollInterval = setInterval(() => {
          //   let el = document.getElementById('incident-jumpers');
          //   if (el) {
          //     el.scrollIntoView();
          //     clearInterval(scrollInterval);
          //   }
          // }, 1000);
        })
        .catch((error) => {
          console.dir(error);
          this.toast.show('Error creating incident', 'error');
        });

      // submit an updated incident
    } else if (this.mode === 'Update') {
      this.loading = true;

      url =
        environment.API_URL +
        '/incidents' +
        '/' +
        this.data.id +
        '/update?userId=' +
        userId;
      axios
        .post(url, this.data, options)
        .then((response) => {
          this.toast.show('Updated Incident ' + this.data.id, 'success');
          this.router.navigate(['/incidents']);
        })
        .catch((error) => {
          this.toast.show('Error updating incident', 'error');
          console.dir(error);
        });
    }
    this.loading = false;
  };

  filterIdentifiers = () => {
    this.identifiers = this.originalIdentifiers;

    let filteredIdentifiers = [];
    this.identifiers.forEach((identifier) => {
      if (
        identifier.areaid === this.data._areaId &&
        identifier.stateid === this.data._stateId &&
        identifier.agencyid === this.data._agencyId
      ) {
        filteredIdentifiers.push(identifier);
      }
    });

    // dedupe identifiers
    let uniqueIdentifiers = [...new Set(filteredIdentifiers)];
    this.identifiers = uniqueIdentifiers;
    this.identifiers.unshift({ name: '', value: '' });
  };

  // generic combobox handler
  onSelectedComboboxItem = (event, datum) => {
    this.data[datum.key] = event.value;
  };

  // generic dropdown handler
  onSelectedDropdownItem = (event, datum) => {
    this.data[datum.key] = event.value;

    if (
      datum.key === '_areaId' ||
      datum.key === '_stateId' ||
      datum.key === '_agencyId'
    ) {
      this.filterIdentifiers();
    }
  };

  isFieldRequired = (datum) => {
    let required = false
    if (datum.required) {
      required = true
    }

    if (this.data._mode === 'Fire Jump' || this.data._mode === 'Proficiency / Training Jump') {
      if (datum.key === '_hobbsTime') {
        required = true
      }
    }

    if (this.data._mode === 'Fire Jump') {
      if (datum.key === '_longitude' || datum.key === '_latitude') {
        required = true
      }
    }

    return required
  }

  areChutesRequired = () => {
    if (
      this.data._mode === 'Other Jump' ||
      this.data._mode === 'Rescue Jump' ||
      this.data._mode === 'Proficiency / Training Jump' ||
      this.data._mode === 'Fire Jump'
    ) {
      return true;
    } else {
      return false;
    }
  };

  // hitting the "Add Jumper" button will bring up a confirm / cancel modal
  addJumper = () => {
    let jumper = {
      Base: this.selectedBase.value,
      JumperId: this.selectedJumper.id,
      T1: this.T1,
      T2: this.T2,
      T3: this.T3,
      arrivalDate: this.jumperArrivalDate,
      arrivalTime: this.jumperArrivalTime,
      drogueId: this.selectedDrogueChute.id,
      homeBaseId: this.selectedJumper.base.id,
      jumpOrder: this.incidentJumpers.length,
      jumpRating: this.jumpRating.value.toString(),
      jumperName:
        this.selectedJumper.lastName + ', ' + this.selectedJumper.firstName,
      main: null,
      mainId: this.selectedMainChute.id,
      position1Id: this.selectedPosition1.id,
      position2Id: this.selectedPosition2.id,
      position3Id: this.selectedPosition3.id,
      reserveId: this.selectedReserveChute.id,
      returnDate: this.jumperReturnDate,
      returnTime: this.jumperReturnTime,
      totalDays: this.totalDays
    };
    this.modal = {
      data: {
        content: 'Are you sure you want to add this jumper?',
        deny: 'Cancel',
        confirm: 'Add Jumper',
        action: 'addJumper',
        jumper: jumper
      },
      active: true
    };
  };

  // validation for the add jumper button
  isAddJumperInvalid = () => {
    if (this.selectedJumper.id !== '' && this.selectedBase.value) {
      // some modes require a main and reserve chute to be selected
      if (this.areChutesRequired()) {
        if (
          this.selectedReserveChute.id !== '' &&
          this.selectedMainChute.id !== ''
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  // get the incident jumper data from the form and then update it
  updateFormJumper = () => {
    let incidentJumperData = this.incidentJumpers.filter((jumper) => {
      return jumper.JumperId === this.selectedJumper.id;
    });
    let incidentJumper = incidentJumperData[0];
    let id = incidentJumper.href.slice(
      incidentJumper.href.lastIndexOf('/') + 1,
      incidentJumper.href.length
    );
    let jumpOrder = this.incidentJumpers.findIndex(
      (jumper) => jumper.href === incidentJumper.href
    );
    let jumper = {
      incidentId: Number(this.data.id),
      Base: this.selectedBase.value,
      JumperId: this.selectedJumper.id,
      Jumper: this.selectedJumper.friendly,
      T1: this.T1,
      T2: this.T2,
      T3: this.T3,
      chuteType: '',
      arrivalDate: this.jumperArrivalDate,
      arrivalTime: this.jumperArrivalTime,
      drogue: null,
      drogueId: this.selectedDrogueChute.value,
      homeBaseId: this.selectedJumper.base.id,
      hideEdit: false,
      jumpOrder: jumpOrder,
      jumpRating: this.jumpRating.value.toString(),
      jumperName:
        this.selectedJumper.lastName + ', ' + this.selectedJumper.firstName,
      main: null,
      mainId: this.selectedMainChute.value,
      position1Id: this.selectedPosition1.id,
      position2Id: this.selectedPosition2.id,
      position3Id: this.selectedPosition3.id,
      Pos1: this.selectedPosition1.id,
      Pos2: this.selectedPosition2.id,
      Pos3: this.selectedPosition3.id,
      reserve: null,
      reserveId: this.selectedReserveChute.value,
      returnDate: this.jumperReturnDate,
      returnTime: this.jumperReturnTime,
      totalDays: this.totalDays
    };
    this.updateJumper(jumper, id);
  };

  // send request to backend to update an incident jumper
  updateJumper = (jumper, id) => {
    this.loading = true;
    let userId = this.userInfo.id;
    const options = {
      headers: { Authorization: 'Bearer ' + this.token }
    };

    let url =
      environment.API_URL +
      '/incidentjumper/' +
      id +
      '/update?userId=' +
      userId;

    axios
      .post(url, jumper, options)
      .then((response) => {
        this.toast.show('Updated Jumper', 'success');
        // refresh the IJ display to show the updated data
        this.refreshIncidentJumpers();
        // clear the IJ form after updating the IJ
        this.cancelJumperEdit();
        // scroll to the updated IJ
        let updatedJumperDOMElement = document.getElementById(jumper.JumperId);
        updatedJumperDOMElement.scrollIntoView();
      })
      .catch((error) => {
        this.loading = false;
        this.toast.show('Error Updating Jumper', 'error');
        console.dir(error);
      });
  };

  moveJumper = (direction, jumper, index) => {
    // can not move higher
    if (direction === 'up' && index === 0) {
      return;
    }
    // can not move lower
    if (direction === 'down' && index === this.incidentJumpers.length - 1) {
      return;
    }

    let targetIndex = index + (direction === 'up' ? -1 : 1);
    let target = this.incidentJumpers[targetIndex];
    this.incidentJumpers[targetIndex] = jumper;
    this.incidentJumpers[index] = target;
    let jumpOrder = this.incidentJumpers.findIndex(
      (ij) => jumper.href === ij.href
    );
    jumper.jumpOrder = jumpOrder;
    jumpOrder = this.incidentJumpers.findIndex((ij) => target.href === ij.href);
    target.jumpOrder = jumpOrder;
    this.updateJumper(target, Number(target.id));
    this.updateJumper(jumper, Number(jumper.id));
  };

  confirmDeleteJumper = (jumper, index) => {
    this.modal = {
      data: {
        content: 'Are you sure you want to remove this jumper?',
        deny: 'Cancel',
        confirm: 'Delete',
        action: 'delete',
        jumper: jumper,
        index: index
      },
      active: true
    };
  };

  confirmCopyToAll = () => {
    this.modal = {
      active: true,
      data: {
        content: 'Are you sure you want to Copy to All?',
        deny: 'No',
        confirm: 'Yes',
        action: 'copy'
      }
    };
  };

  modalDenied = (data) => {
    this.modal.active = false;
  };

  modalConfirmed = async (data) => {
    let userId = this.userInfo.id;

    const options = {
      headers: { Authorization: 'Bearer ' + this.token }
    };

    // delete incident jumper
    if (data.action === 'delete') {
      this.loading = true;
      let id = data.jumper.href.slice(
        data.jumper.href.lastIndexOf('/') + 1,
        data.jumper.href.length
      );
      let url =
        environment.API_URL +
        '/incidentjumper/' +
        id +
        '/delete?userId=' +
        userId;

      axios
        .delete(url, options)
        .then((deleted) => {
          this.incidentJumpers.splice(data.index, 1);
          this.toast.show('Removed Jumper ' + id, 'success');
          this.refreshIncidentJumpers();
          this.modal.active = false;
        })
        .catch((error) => {
          this.loading = false;
          this.toast.show('Error removing Jumper', 'error');
          console.dir(error);
        });
    }

    // copy to all
    if (data.action === 'copy') {
      for (let index = 0; index < this.incidentJumpers.length; index++) {
        const jumper = this.incidentJumpers[index];

        jumper.arrivalTime = this.jumperArrivalTime;
        jumper.arrivalDate = this.jumperArrivalDate;
        jumper.returnDate = this.jumperReturnDate;
        jumper.returnTime = this.jumperReturnTime;
        jumper.totalDays = this.totalDays;

        this.updateJumper(jumper, jumper.id);
      }
      this.modal.active = false;
    }

    // add incident jumper
    if (data.action === 'addJumper') {
      let url =
        environment.API_URL +
        '/incidentjumper/' +
        this.data.id +
        '/singleAdd?userId=' +
        userId;

      axios
        .post(url, data.jumper, options)
        .then((response) => {
          this.toast.show('Added Jumper', 'success');
          this.refreshIncidentJumpers();
          this.modal.active = false;
          this.cancelJumperEdit();
        })
        .catch((error) => {
          this.toast.show('Error adding Jumper', 'error');
          this.modal.active = false;
          console.dir(error);
        });
    }
  };

  refreshIncidentJumpers = () => {
    this.loading = true;
    axios
      .get(
        environment.API_URL +
          '/incidentjumper?incidentId=' +
          this.data.id +
          '&archived=true',
        {
          headers: { Authorization: 'Bearer ' + this.token }
        }
      )
      .then((response) => {
        this.incidentJumpers = response.data.value;
        this.incidentJumpers.forEach((jumper) => {
          let id = jumper.href.slice(
            jumper.href.lastIndexOf('/') + 1,
            jumper.href.length
          );
          jumper.id = id;
          if (jumper.position1Id) {
            let position = this.qualifications.filter((qualification) => {
              return qualification.id === jumper.position1Id;
            });
            jumper.position1 = position[0].title;
          }
          if (jumper.position2Id) {
            let position = this.qualifications.filter((qualification) => {
              return qualification.id === jumper.position2Id;
            });
            jumper.position2 = position[0].title;
          }
          if (jumper.position3Id) {
            let position = this.qualifications.filter((qualification) => {
              return qualification.id === jumper.position3Id;
            });
            jumper.position3 = position[0].title;
          }
          if (jumper.mainId) {
            let main = this.allUnfilteredChutes.main.filter((chute) => {
              let id = chute.href.slice(
                chute.href.lastIndexOf('/') + 1,
                chute.href.lastIndexOf('?') !== -1 ? chute.href.lastIndexOf('?') : chute.href.length + 1
              );
              return jumper.mainId.toString() === id.toString();
            });
            jumper.main = main[0]?.main;
          }
          
          if (jumper.drogueId) {
            let drogue = this.allUnfilteredChutes.drogue.filter((chute) => {
              let id = chute.href.slice(
                chute.href.lastIndexOf('/') + 1,
                chute.href.lastIndexOf('?') !== -1 ? chute.href.lastIndexOf('?') : chute.href.length + 1
              );
              return jumper.drogueId.toString() === id.toString();
            });
            jumper.drogue = drogue[0]?.drogue;
          }
          
          if (jumper.reserveId) {
            let reserve = this.allUnfilteredChutes.reserve.filter((chute) => {
              let id = chute.href.slice(
                chute.href.lastIndexOf('/') + 1,
                chute.href.lastIndexOf('?') !== -1 ? chute.href.lastIndexOf('?') : chute.href.length + 1
              );
              return jumper.reserveId.toString() === id.toString();
            });
            jumper.reserve = reserve[0]?.reserve;
          }
          if (jumper.arrivalDate) {
            let date = jumper.arrivalDate.split('-');
            jumper.friendlyArrivalDate =
              Number(date[1]) + '/' + date[2].slice(0, 2) + '/' + date[0];
          }
          if (jumper.arrivalTime) {
            if (jumper.arrivalTime.includes(':')) {
              jumper.friendlyArrivalTime = jumper.arrivalTime;
            } else {
              jumper.friendlyArrivalTime =
                jumper.arrivalTime[0] +
                jumper.arrivalTime[1] +
                ':' +
                jumper.arrivalTime[2] +
                jumper.arrivalTime[3];
            }
          }
          if (jumper.returnTime) {
            if (jumper.returnTime.includes(':')) {
              jumper.friendlyReturnTimeTime = jumper.returnTime;
            } else {
              jumper.friendlyReturnTime =
                jumper.returnTime[0] +
                jumper.returnTime[1] +
                ':' +
                jumper.returnTime[2] +
                jumper.returnTime[3];
            }
          }
          if (jumper.returnDate) {
            let date = jumper.returnDate.split('-');
            jumper.friendlyReturnDate =
              Number(date[1]) + '/' + date[2].slice(0, 2) + '/' + date[0];
          }
        });

        // sort jumpers by jump jumpOrder
        this.incidentJumpers = this.sort(this.incidentJumpers, 'jumpOrder');
        this.loading = false;
      })

      .catch((error) => {
        this.loading = false;
        console.dir(error);
      });
  };

  sort = (array, key) => {
    array.sort((a, b) => {
      var keyA = a[key];
      var keyB = b[key];
      if (keyA < keyB) {
        return -1;
      }
      if (keyA > keyB) {
        return 1;
      }
      return 0;
    });
    return array;
  };

  selectMainChute = (event) => {
    this.selectedMainChute = event;
  };
  selectDrogueChute = (event) => {
    this.selectedDrogueChute = event;
  };
  selectReserveChute = (event) => {
    this.selectedReserveChute = event;
  };
  selectJumper = (event) => {
    this.selectedJumper = event;
  };
  selectBase = (event) => {
    this.selectedBase = event;
    this.getJumpers();
    this.putSelectedBaseChutesOnTop();
  };
  selectJumpRating = (event) => {
    this.jumpRating = event;
  };
  selectJumperPosition = (event, position) => {
    if (position === 1) {
      this.selectedPosition1 = event;
    }
    if (position === 2) {
      this.selectedPosition2 = event;
    }
    if (position === 3) {
      this.selectedPosition3 = event;
    }
  };

  // put the chutes belonging to the selected base at the top of their respective lists
  putSelectedBaseChutesOnTop = () => {
    this.mainChutes = this.sort(this.mainChutes, 'Base');
    let baseMains = this.mainChutes.filter((chute) => {
      return chute.Base === this.selectedBase.value;
    });
    let otherMains = this.mainChutes.filter((chute) => {
      return chute.Base !== this.selectedBase.value;
    });
    this.mainChutes = baseMains.concat(otherMains);

    this.drogueChutes = this.sort(this.drogueChutes, 'Base');
    let baseDrogues = this.drogueChutes.filter((chute) => {
      return chute.Base === this.selectedBase.value;
    });
    let otherDrogues = this.drogueChutes.filter((chute) => {
      return chute.Base !== this.selectedBase.value;
    });
    this.drogueChutes = baseDrogues.concat(otherDrogues);

    this.reserveChutes = this.sort(this.reserveChutes, 'Base');
    let baseReserves = this.reserveChutes.filter((chute) => {
      return chute.Base === this.selectedBase.value;
    });
    let otherReserves = this.reserveChutes.filter((chute) => {
      return chute.Base !== this.selectedBase.value;
    });
    this.reserveChutes = baseReserves.concat(otherReserves);
  };

  getSizeClass = () => {
    let size = 'A';
    if (this.data._acres > 0.25) {
      size = 'B';
    }
    if (this.data._acres >= 10) {
      size = 'C';
    }
    if (this.data._acres >= 100) {
      size = 'D';
    }
    if (this.data._acres >= 300) {
      size = 'E';
    }
    if (this.data._acres >= 1000) {
      size = 'F';
    }
    if (this.data._acres >= 5000) {
      size = 'G';
    }
    return size;
  };

  // enforce only numbers, decimal points, and spaces for lat/long inputs
  checkLongLatChar = (event) => {
    let testChar = /[0-9\s\d.]+/
    if (!testChar.test(event.key)) {
      event.preventDefault()
    }
  }

  // determines the css class for help text
  isHelpValid = (datum) => {
    if (datum.key === '_latitude') {
      let regex = new RegExp(
        '(\\d\\d\\s\\d\\d\\.\\d\\d\\d\\d$)'
      );
      datum.valid = regex.test(this.data[datum.key]);
    }
    if (datum.key === '_longitude') {
      let regex = new RegExp(
        '(\\d\\d\\s\\d\\d\\.\\d\\d\\d\\d$|\\d\\d\\d\\s\\d\\d\\.\\d\\d\\d\\d$)'
      );
      datum.valid = regex.test(this.data[datum.key]);
    }
    if (datum.key === '_hobbsTime') {
      let regex = new RegExp('^\\d+(\\.\\d+)*$');
      datum.valid = regex.test(this.data[datum.key]);
    }
    if (datum.key === '_departTimeMilitary') {
      let regex = new RegExp('^\\d\\d+\\:\\d+$|\\d\\:\\d\\d$');
      datum.valid = regex.test(this.data[datum.key]);
    }
    if (this.data[datum.key]) {
      if (datum.valid) {
        return 'valid';
      } else {
        return 'invalid';
      }
    } else {
      return '';
    }
  };

  // incident form validation, disables / enables the submit button
  // by default the form is valid (invalid = false)
  // if any validity conditions fail, set invalid to true
  isInvalid = () => {
    let invalid = false;

    // validate that all required fields have a value
    if (
      !this.data._incidentDate ||
      !this.data._nameofIncident ||
      !this.data._dispatchedFrom_Code ||
      !this.data._areaId ||
      !this.data._stateId ||
      !this.data._methodOfTravel_Id ||
      !this.data._mode ||
      !this.data._mission
    ) {
      invalid = true;
    }

    // if _departTimeMilitary has a value, validate it's format
    let departedRegex = new RegExp('^\\d\\d+\\:\\d+$|\\d\\:\\d\\d$');
    if (this.data._departTimeMilitary) {
      if (!departedRegex.test(this.data._departTimeMilitary)) {
        invalid = true;
      }
    }

    // validate additional required fields for Proficiency / Training Jump
    if (this.data._mode === 'Proficiency / Training Jump') {
      let hobbsregex = new RegExp('^\\d+(\\.\\d+)*$');
      if (!hobbsregex.test(this.data._hobbsTime)) {
        invalid = true;
      }
    }

    // validate additional required fields for Fire Jump
    if (this.data._mode === 'Fire Jump') {
      let latregex = new RegExp(
        '(\\d\\d\\s\\d\\d\\.\\d\\d\\d\\d$)'
      );
      let longregex = new RegExp(
        '(\\d\\d\\s\\d\\d\\.\\d\\d\\d\\d$|\\d\\d\\d\\s\\d\\d\\.\\d\\d\\d\\d$)'
      );
      let hobbsregex = new RegExp('^\\d+(\\.\\d+)*$');
      if (
        !latregex.test(this.data._latitude) ||
        !longregex.test(this.data._longitude) ||
        !hobbsregex.test(this.data._hobbsTime)
      ) {
        invalid = true;
      }
    }

    return invalid;
  };

  // load an incident jumper into the IJ form
  editJumper = async (jumper, index) => {
    this.loading = true;
    // clear the form of any prior data
    this.cancelJumperEdit();

    // get the full jumper data for the incident jumper display
    let friendlyName = jumper.jumperName + ' | ' + jumper.Base;
    let jumperData = this.allJumpers.filter((j) => {
      return j.id === jumper.JumperId;
    });
    jumperData = jumperData[0];

    // If the chute is inactive, it won't be in the dropdown list.
    // Specifically get the chute in question

    let mainChute = this.allUnfilteredChutes.main.find((chute) => {
      return chute.id === jumper.mainId;
    });
    let drogueChute = this.allUnfilteredChutes.drogue.find((chute) => {
      return chute.id === jumper.drogueId;
    });
    let reserveChute = this.allUnfilteredChutes.reserve.find((chute) => {
      return chute.id === jumper.reserveId;
    });

    if (mainChute) {
      this.selectedMainChute = mainChute;
      if (! this.mainChutes.indexOf(mainChute)) {
        this.mainChutes.push(mainChute);
      }
    }
    if (drogueChute) {
      this.selectedDrogueChute = drogueChute;
      if (! this.drogueChutes.indexOf(drogueChute)) {
        this.drogueChutes.push(drogueChute);
      }
    }
    if (reserveChute) {
      this.selectedReserveChute = reserveChute;
      if (! this.reserveChutes.indexOf(reserveChute)) {
        this.reserveChutes.push(reserveChute);
      }
    }

    // make the jumper's base the selected base and repopulate the jumper dropdown with jumpers from that base
    let jumperBase = this.bases.filter((base) => {
      return base.baseCode === jumper.Base
    })
    this.selectBase(jumperBase[0])

    this.selectedJumper = jumperData;
    if (jumper.position1Id) {
      let pos1 = this.qualifications.filter((qualification) => {
        return qualification.id === jumper.position1Id;
      });
      this.selectedPosition1 = pos1[0];
    }
    if (jumper.position2Id) {
      let pos2 = this.qualifications.filter((qualification) => {
        return qualification.id === jumper.position2Id;
      });
      this.selectedPosition2 = pos2[0];
    }
    if (jumper.position3Id) {
      let pos3 = this.qualifications.filter((qualification) => {
        return qualification.id === jumper.position3Id;
      });
      this.selectedPosition3 = pos3[0];
    }
    this.T1 = jumper.T1;
    this.T2 = jumper.T2;
    this.T3 = jumper.T3;
    this.jumpRating = {
      name: jumper.jumpRating,
      value: jumper.jumpRating
    };
    if (jumper.totalDays) {
      this.totalDays = jumper.totalDays;
    }
    if (jumper.returnDate) {
      this.jumperReturnDate = jumper.returnDate.slice(0, 10);
    }
    if (jumper.returnTime) {
      this.jumperReturnTime = jumper.returnTime.slice(0,2) + ':' + jumper.returnTime.slice(2,4);
    }
    if (jumper.arrivalDate) {
      this.jumperArrivalDate = jumper.arrivalDate.slice(0, 10);
    }
    if (jumper.arrivalTime) {
      this.jumperArrivalTime = jumper.arrivalTime.slice(0,2) + ':' + jumper.arrivalTime.slice(2,4);
    }

    this.editingJumper = true;
    let jumperForm = document.getElementById('jumperForm');
    jumperForm.scrollIntoView();
    this.loading = false;
  };

  // clear the IJ form
  cancelJumperEdit = () => {
    this.editingJumper = false;
    this.selectedMainChute = {
      id: '',
      name: '',
      value: ''
    };
    this.selectedDrogueChute = {
      id: '',
      value: ''
    };
    this.selectedReserveChute = {
      id: '',
      value: ''
    };
    this.selectedBase = {
      baseCode: '',
      value: ''
    };
    this.selectedJumper = {
      friendly: '',
      id: '',
      base: {
        id: ''
      },
      lastName: '',
      firstName: '',
      name: '',
      value: ''
    };
    this.selectedPosition1 = {
      id: ''
    };
    this.selectedPosition2 = {
      id: ''
    };
    this.selectedPosition3 = {
      id: ''
    };
    this.T1 = null;
    this.T2 = null;
    this.T3 = null;
    this.jumpRating = {
      name: '',
      value: ''
    };
    this.totalDays = null;
    this.jumperReturnDate = null;
    this.jumperArrivalDate = null;
    this.jumperReturnTime = null;
    this.jumperArrivalTime = null;    
  };

  goToIncidents = () => {
    this.router.navigate(['incidents']);
  };
}
